import { SET_TIME_ZONE, SET_TIME_ZONE_IS_INITED } from './timeZoneConstants'
import { LOGOUT } from '../../app/authState'

const initialState = {
  isInited: false,
  initialTimeZone: null,
}
export const timeZoneReducer = (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case SET_TIME_ZONE: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      return { ...state, initialTimeZone: action.payload }
    }
    case SET_TIME_ZONE_IS_INITED: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      return { ...state, isInited: action.timeZone }
    }
    case LOGOUT: {
      return initialState
    }
    default: {
      return state
    }
  }
}
